import { render, staticRenderFns } from "./CategoryFilterButton.vue?vue&type=template&id=2b1303b5&scoped=true&"
import script from "./CategoryFilterButton.vue?vue&type=script&lang=js&"
export * from "./CategoryFilterButton.vue?vue&type=script&lang=js&"
import style0 from "./CategoryFilterButton.vue?vue&type=style&index=0&id=2b1303b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1303b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
